import { styled } from '../../../../../modules';

export const Container = styled.a`
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 6px;
    text-decoration: none;
`;

export const PoweredBy = styled.span`
    font-size: 11px;
    color: #999;
    font-style: italic;
`;

export const Brand = styled.span`
    font-size: 11px;
    color: #999;
    font-style: normal;
    margin-left: -2px;
`;
